import type {
  CampaignColumn,
  CampaignColumnValue,
} from 'services/campaignColumns'

import type { EmailVariable } from '../email-variables'
import {
  isUsableCampaignColumnValue,
  useApprovedCampaignColumnValues,
} from './useApprovedCampaignColumnValues'

export function buildCampaignVariables(
  columns: ReadonlyArray<CampaignColumn>,
  valueRowsByColumn: ReadonlyArray<
    ReadonlyArray<CampaignColumnValue> | undefined
  >
): ReadonlyArray<EmailVariable> {
  return columns.map((column, index) => {
    const totalCount = column.progress.total_contacts
    const rows = valueRowsByColumn[index]
    const validCount = rows
      ? rows.filter(isUsableCampaignColumnValue).length
      : column.progress.valid_values
    const missingCount = Math.max(0, totalCount - validCount)

    return {
      value: `{${column.merge_variable_slug.toUpperCase()}}`,
      label: column.name,
      token: column.merge_variable_slug.toUpperCase(),
      isCampaignColumn: true,
      isManual: column.engine_type === 'manual',
      isAI: column.engine_type !== 'manual',
      missingCount,
      totalCount,
      hasMissingValues: missingCount > 0,
    }
  })
}

/**
 * Derive the list of custom campaign column variables for use in email
 * variable pickers. Returns an empty array when campaignId is undefined or
 * while the query is loading.
 */
export function useCampaignVariables(
  campaignId: number | undefined
): ReadonlyArray<EmailVariable> {
  const { columns, valueQueries } = useApprovedCampaignColumnValues(campaignId)

  return buildCampaignVariables(
    columns,
    valueQueries.map((query) => query.data?.results)
  )
}
